const POKEMON_LIST_REQUEST = 'POKEMON_LIST_REQUEST';
const POKEMON_LIST_SUCCESS = 'POKEMON_LIST_SUCCESS';
const POKEMON_LIST_FAILURE = 'POKEMON_LIST_FAILURE';

const POKEMON_REQUEST = 'POKEMON_REQUEST';
const POKEMON_SUCCESS = 'POKEMON_SUCCESS';
const POKEMON_FAILURE = 'POKEMON_FAILURE';

const POKEMON_ADD_REQUEST = 'POKEMON_ADD_REQUEST';
const POKEMON_ADD_SUCCESS = 'POKEMON_ADD_SUCCESS';
const POKEMON_ADD_FAILURE = 'POKEMON_ADD_FAILURE';

const POKEMON_EDIT_REQUEST = 'POKEMON_EDIT_REQUEST';
const POKEMON_EDIT_SUCCESS = 'POKEMON_EDIT_SUCCESS';
const POKEMON_EDIT_FAILURE = 'POKEMON_EDIT_FAILURE';

const POKEMON_DELETE_REQUEST = 'POKEMON_DELETE_REQUEST';
const POKEMON_DELETE_SUCCESS = 'POKEMON_DELETE_SUCCESS';
const POKEMON_DELETE_FAILURE = 'POKEMON_DELETE_FAILURE';

const POKEMON_MOVES_REQUEST = 'POKEMON_MOVES_REQUEST';
const POKEMON_MOVES_SUCCESS = 'POKEMON_MOVES_SUCCESS';
const POKEMON_MOVES_FAILURE = 'POKEMON_MOVES_FAILURE';

const POKEMON_CHANGE_QUERY = 'POKEMON_CHANGE_QUERY';


const types = {
    POKEMON_LIST_REQUEST,
    POKEMON_LIST_SUCCESS,
    POKEMON_LIST_FAILURE,
    
    POKEMON_REQUEST,
    POKEMON_SUCCESS,
    POKEMON_FAILURE,

    POKEMON_ADD_REQUEST,
    POKEMON_ADD_SUCCESS,
    POKEMON_ADD_FAILURE,

    POKEMON_EDIT_REQUEST,
    POKEMON_EDIT_SUCCESS,
    POKEMON_EDIT_FAILURE,

    POKEMON_DELETE_REQUEST,
    POKEMON_DELETE_SUCCESS,
    POKEMON_DELETE_FAILURE,

    POKEMON_MOVES_REQUEST,
    POKEMON_MOVES_SUCCESS,
    POKEMON_MOVES_FAILURE,
    
    POKEMON_CHANGE_QUERY,
}

export default types;